import React from 'react'

const stats = [
  {
    number: '1.2M+',
    title: 'Parcels Delivered',
    detail: 'Moving businesses forward'
  },
  {
    number: '300+',
    title: 'Fleet Strength',
    detail: 'A growing transport network'
  },
  {
    number: '1.5M+',
    title: 'Sq. Ft. Operational Space',
    detail: 'Built for scale and efficiency'
  },
  {
    number: '19K+',
    title: 'PIN Codes Covered',
    detail: 'Connecting destinations across India'
  },
  {
    number: '1 Lakh+',
    title: 'Delivery Network',
    detail: 'People powering every delivery'
  },
  {
    number: '24/7',
    title: 'Logistics Support',
    detail: 'Reliable assistance whenever needed'
  }
]

const StatsSection = () => {
  return (
    <section
      className='
      relative w-full overflow-hidden
      bg-[#f7f6f3]
      py-5 sm:py-6
      md:py-7
      lg:py-8
    '
    >
      <div
        className='
        mx-auto
        max-w-[1350px]
        px-5 sm:px-7
        md:px-8
        lg:px-10
      '
      >
        {/* SECTION HEADING */}
        <div
          className='
          mb-5 sm:mb-5
          flex flex-col
          justify-between
          gap-5
          md:mb-10
          lg:flex-row
          lg:items-end
        '
        >
          <div className='max-w-[650px]'>
            <h2
              className='
              text-[30px]
              sm:text-[36px]
              md:text-[43px]
              lg:text-[46px]
              font-semibold
              leading-[1.12]
              tracking-[-1.5px]
              text-[#211f57]
            '
            >
              A Network Built
              <br />
              <span className='text-[#d32c30]'>To Move More.</span>
            </h2>
          </div>

          <p
            className='
            max-w-[440px]
            text-[12px]
            sm:text-[13px]
            leading-6 sm:leading-7
            text-[#777]
            lg:pb-1
          '
          >
            Every number represents our commitment to dependable logistics,
            stronger connections and seamless deliveries across India.
          </p>
        </div>

        {/* STATISTICS GRID */}
        <div
          className='
  grid grid-cols-2
  md:grid-cols-3
  xl:grid-cols-6
  border-t border-[#dcd9d3]
'
        >
          {stats.map((item, index) => (
            <div
              key={item.title}
              className={`
        group relative
        flex min-h-[165px]
        sm:min-h-[185px]
        xl:min-h-[190px]
        flex-col justify-between
        px-3 sm:px-4 xl:px-3 2xl:px-4
        py-6 sm:py-7
        transition-all duration-300
        hover:bg-white

        ${index % 2 !== 0 ? 'border-l border-[#dcd9d3]' : ''}

        ${index >= 2 ? 'border-t border-[#dcd9d3] md:border-t-0' : ''}

        ${index % 3 !== 0 ? 'md:border-l border-[#dcd9d3]' : ''}

        ${index >= 3 ? 'md:border-t border-[#dcd9d3] xl:border-t-0' : ''}

        ${index % 6 !== 0 ? 'xl:border-l border-[#dcd9d3]' : ''}
      `}
            >
              <div className='mt-3'>
                <h3
                  className='
          text-[clamp(24px,2.5vw,34px)]
          font-bold tracking-[-1.5px]
          leading-tight
          text-[#211f57]
          transition-colors duration-300
          group-hover:text-[#d32c30]
        '
                >
                  {item.number}
                </h3>

                <p
                  className='
          mt-2 text-[11px] sm:text-[12px]
          font-semibold leading-snug text-[#333]
        '
                >
                  {item.title}
                </p>

                <p
                  className='
          mt-1 text-[9px] sm:text-[10px]
          leading-5 text-[#929292]
        '
                >
                  {item.detail}
                </p>
              </div>

              <span
                className='
        absolute bottom-0 left-0
        h-[2px] w-0 bg-[#d32c30]
        transition-all duration-300
        group-hover:w-full
      '
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default StatsSection
